import { persistentReducedStream, reducer } from '@ardoq/rxbeach';
import {
  ContextSort,
  getDefaultSort,
  NumericSortOrder,
  returnPayload,
} from '@ardoq/common-helpers';
import {
  contextWorkspaceChanged,
  ContextWorkspaceChangedPayload,
  setSort,
} from './ContextActions';

const initialState: ContextSort = getDefaultSort();

const applyWorkspaceDefaultSort = (
  currentSort: ContextSort,
  { workspace }: ContextWorkspaceChangedPayload
): ContextSort => {
  if (!workspace.defaultSort) return currentSort;
  if (currentSort.attr === workspace.defaultSort) return currentSort;

  return {
    attr: workspace.defaultSort,
    name: undefined,
    order: NumericSortOrder.ASC,
  };
};

export const sort$ = persistentReducedStream('sort$', initialState, [
  reducer(setSort, returnPayload),
  reducer(contextWorkspaceChanged, applyWorkspaceDefaultSort),
]);
